// src/firebase/firebase.js

import { initializeApp } from 'firebase/app';
import { collection, getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const env = process.env.REACT_APP_ENV;

const firebaseProdConfig = {
    apiKey: "AIzaSyBu6R1zXT4OKWunsBS-0MY7woiiARbgqQA",
    authDomain: "operataxis.firebaseapp.com",
    projectId: "operataxis",
    storageBucket: "operataxis.firebasestorage.app",
    messagingSenderId: "784489366927",
    appId: "1:784489366927:web:06c0b1d63beba63e9377fa",
    measurementId: "G-TPWK71TL9L"
  };

const firebaseDevConfig = {
    apiKey: "AIzaSyBu6R1zXT4OKWunsBS-0MY7woiiARbgqQA",
    authDomain: "operataxis.firebaseapp.com",
    projectId: "operataxis",
    storageBucket: "operataxis.firebasestorage.app",
    messagingSenderId: "784489366927",
    appId: "1:784489366927:web:06c0b1d63beba63e9377fa",
    measurementId: "G-TPWK71TL9L"
  };

const projectConfig = env === "dev" ? firebaseDevConfig : firebaseProdConfig;
console.log('env================>: ', env);

// Initialize Firebase
const app = initializeApp(projectConfig);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Firebase Functions and get a reference to the service
export const functions = getFunctions(app);

// Firestore collection references
export const complaints = collection(db, 'complaints');

export const refs = {
    complaints
};